import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
// import { RecentActivitiesService } from '@/services/recent-activities/recent-activities.service';
import { State } from '@/store/login/reducer';
import { ApprovalsService } from '../../../../../services/approvals/approvals.service';
import { LoginResponse } from '@/auth/interface/auth.interface';
import { filter } from 'rxjs/operators';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';

@Component({
  selector: 'app-mine-license-manager',
  templateUrl: './mine-license-manager.component.html',
  styleUrls: ['./mine-license-manager.component.css'],
})
export class MineLicenseManagerComponent implements OnInit {

  show0 = true;
  show1 = true;
  show2 = true;
  requestApproverPendingReview: number = 0

  userData: Partial<LoginResponse> = {};

  constructor(
    private serviceApprover: ApprovalsService,
    private store: Store<StoreState>,
  ) {
    const storeLoginSlice$ = getCurrentUserData(this.store);

    storeLoginSlice$.subscribe({
      next: (userData) => {
        this.userData = userData;
      },
    });
  }

  ngOnInit(): void {
    this.getActivitiesTask();
  }

  toggle(id: number) {
    switch (id) {
      case 0: {
        this.show0 = !this.show0;
        break;
      }
      case 1: {
        this.show1 = !this.show1;
        break;
      }
      case 2: {
        this.show2 = !this.show2;
        break;
      }
      default:
        break;
    }
  }

  getActivitiesTask() {
    if (this.userData.mdmid) {
      this.serviceApprover.getTotalRequestApprovalCount(this.userData.mdmid)
        .subscribe((res) => {
          this.requestApproverPendingReview = res;
          // this.requestApproverPendingReview = res.filter((item) => item.task === 'Solicitud de Aprobacion').length;
        });
    }
  }
}
